import React, { useEffect, useState } from "react";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { KendoLoader } from "../../Kendo/kendo_loader";
import FacilityForm from "./FacilityForm";
import { SeatingForm } from "./SeatingForm";
import { FeaturesForm } from "./FeaturesForm";
import { VirtualImageMapping } from "./VirtualImageMapping";
import {
  Button,
  checkAccess,
  confirmDelete,
  ErrorMsg,
  GetFormData,
  sessionUser,
  ValidateForm,
} from "../../Util/common";
import { LayoutForm } from "./LayoutForm";
import {
  CorebaseURL,
  CorebaseURLs,
  corefetch,
  corepost,
  ImageURL,
} from "../../Util/axios_core_helper";

export const FacilityList = () => {
  const [facilityDetails, setFacilityDetails] = useState({
    FacilityForm: {},
    SeatingDetails: [],
    removedRoomSeatingIds: "",
    removedFeatureIds: "",
    removedVirtualMappingIds: "",
    Features: [],
    VirtualMapping: [],
    Layout: [],
  });
  const [isEditMode, setIsEditMode] = useState(false);
  const [refreshflag, setrefreshflag] = useState(0);
  const [editVisible, setEditVisible] = useState(false);
  const [title, setTitle] = useState("");

  const [WelcomeToList, setWelcomeToList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const goNext = () =>
    setCurrentStep((prev) => Math.min(prev + 1, steps.length - 1));
  const goBack = () => setCurrentStep((prev) => Math.max(prev - 1, 0));
  const [facilityData, setFacilityData] = useState([]);
  const [Loading, setLoading] = useState(false);

  const handleSubmit = async (e, imageList, removedImageIds) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("LayoutRemovedImageIds", removedImageIds || "");
    formData.append(
      "RemovedRoomSeatingIDs",
      facilityDetails.removedRoomSeatingIds || ""
    );
    formData.append(
      "RemovedFeatureIDs",
      facilityDetails.removedFeatureIds || ""
    );
    formData.append(
      "RemovedVirtualMappingIDs",
      facilityDetails.removedVirtualMappingIds || ""
    );
    formData.append(
      "FacilityID",
      facilityDetails.FacilityForm?.FacilityID || 0
    );
    formData.append(
      "FacilityName",
      facilityDetails.FacilityForm?.FacilityName || ""
    );
    formData.append("Height", facilityDetails.FacilityForm?.Height || 0);
    formData.append("FloorArea", facilityDetails.FacilityForm?.FloorArea || "");
    formData.append(
      "StandardRate",
      facilityDetails.FacilityForm?.StandardRate || 0
    );
    formData.append(
      "MinimumRate",
      facilityDetails.FacilityForm?.MinimumRate || 0
    );
    formData.append(
      "BaseCapacity",
      facilityDetails.FacilityForm?.BaseCapacity || 0
    );
    formData.append(
      "MaxCapacity",
      facilityDetails.FacilityForm?.MaxCapacity || 0
    );
    formData.append(
      "SimpleView",
      facilityDetails.FacilityForm?.SimpleView || ""
    );
    formData.append(
      "DetailedView",
      facilityDetails.FacilityForm?.DetailedView || ""
    );
    formData.append("Latitude", facilityDetails.FacilityForm?.Latitude || 0);
    formData.append("Longitude", facilityDetails.FacilityForm?.Longitude || 0);
    formData.append("Image", facilityDetails.FacilityForm?.Image || "");
    formData.append(
      "Description",
      facilityDetails.FacilityForm?.Description || ""
    );
    formData.append(
      "OldImagePath",
      facilityDetails.FacilityForm?.OldImagePath || ""
    );
    formData.append("SavedBy", sessionUser());

    facilityDetails.SeatingDetails.forEach((seating, index) => {
      const guidRegex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      formData.append(
        `SeatingDetails[${index}].SeatingType`,
        seating.seatingType || ""
      );
      formData.append(
        `SeatingDetails[${index}].FacilityID`,
        seating.facilityID || 0
      );
      formData.append(
        `SeatingDetails[${index}].SeatingCapacity`,
        seating.seatingCapacity || ""
      );
      formData.append(`SeatingDetails[${index}].SavedBy`, sessionUser());
      const roomSeatingTypeID = guidRegex.test(seating.roomSeatingTypeID)
        ? 0
        : seating.roomSeatingTypeID;
      formData.append(
        `SeatingDetails[${index}].RoomSeatingTypeID`,
        roomSeatingTypeID
      );
    });

    facilityDetails.Features.forEach((feature, index) => {
      const guidRegex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      const featuresID = guidRegex.test(feature.featuresID)
        ? 0
        : feature.featuresID;
      formData.append(`Features[${index}].FeaturesID`, featuresID);
      formData.append(`Features[${index}].Caption`, feature.caption || "");
      formData.append(`Features[${index}].FacilityID`, feature.facilityID || 0);
      formData.append(`Features[${index}].Value`, feature.value || "");
      formData.append(`Features[${index}].SavedBy`, sessionUser());
    });

    facilityDetails.VirtualMapping.forEach((mapping, index) => {
      const guidRegex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      const virtualMappingID = guidRegex.test(mapping.virtualMappingID)
        ? 0
        : mapping.virtualMappingID;
      formData.append(
        `VirtualMapping[${index}].VirtualMappingID`,
        virtualMappingID
      );
      formData.append(
        `VirtualMapping[${index}].VirutalMappingTitle`,
        mapping.virutalMappingTitle || ""
      );
      formData.append(
        `VirtualMapping[${index}].FacilityID`,
        mapping.facilityID || 0
      );
      formData.append(
        `VirtualMapping[${index}].KuulaLink`,
        mapping.kuulaLink || ""
      );
      formData.append(`VirtualMapping[${index}].Image`, mapping.image || "");
      formData.append(
        `VirtualMapping[${index}].OldImagePath`,
        mapping.oldImagePath || ""
      );
      formData.append(`VirtualMapping[${index}].SavedBy`, sessionUser());
    });

    imageList.forEach((layout, index) => {
      formData.append(`Layout[${index}].Layout_ID`, layout.Layout_ID || 0);
      formData.append(`Layout[${index}].FacilityID`, layout.FacilityID || 0);
      formData.append(`Layout[${index}].Image`, layout.fileData || 0);

      formData.append(
        `Layout[${index}].OldImagePath`,
        layout.OldImagePath || ""
      );
      formData.append(`Layout[${index}].SavedBy`, sessionUser());
    });
    setLoading(true);
    try {
      await corepost(
        "Facility/FacilityInsert",
        formData,
        true,
        true,
        false,
        false
      );
      setrefreshflag(refreshflag + 1);
      setLoading(false);
      toggleModal();
    } catch (error) {
      console.error("Error while submitting facility details:", error);
    }
  };
  const steps = [
    {
      label: "Venue Details",
      content: (
        <FacilityForm
          facilityDetails={facilityDetails}
          setFacilityDetails={setFacilityDetails}
          // handleChange={handleFacilityFormChange}
          goNext={goNext}
        />
      ),
    },
    {
      label: "Seating Details",
      content: (
        <SeatingForm
          facilityDetails={facilityDetails}
          setFacilityDetails={setFacilityDetails}
          goNext={goNext}
          goBack={goBack}
        />
      ),
    },
    {
      label: "Features",
      content: (
        <FeaturesForm
          facilityDetails={facilityDetails}
          setFacilityDetails={setFacilityDetails}
          goNext={goNext}
          goBack={goBack}
        />
      ),
    },
    {
      label: "Virtual Image Mapping",
      content: (
        <VirtualImageMapping
          facilityDetails={facilityDetails}
          setFacilityDetails={setFacilityDetails}
          goNext={goNext}
          goBack={goBack}
        />
      ),
    },
    {
      label: "Layout",
      content: (
        <LayoutForm
          facilityDetails={facilityDetails}
          setFacilityDetails={setFacilityDetails}
          goNext={goNext}
          goBack={goBack}
          handleSubmit={handleSubmit}
          Loading={Loading}
        />
      ),
    },
  ];

  const toggleModal = (isEdit = false) => {
    if (isModalOpen) {
      // Close modal, clear all inputs, and reset to step 0
      setFacilityDetails({
        FacilityForm: {
          FacilityID: 0,
          FacilityName: "",
          Height: 0,
          FloorArea: "",
          StandardRate: 0,
          MinimumRate: 0,
          BaseCapacity: 0,
          MaxCapacity: 0,
          SimpleView: "",
          DetailedView: "",
          Latitude: "",
          Longitude: "",
          Image: "",
          OldImagePath: "",
        },
        SeatingDetails: [],
        Features: [],
        VirtualMapping: [],
        Layout: [],
      });
      setCurrentStep(0);
    }
    setEditVisible(false);
    setIsEditMode(isEdit);
    setIsModalOpen(!isModalOpen);
  };

 const onRowReorderChange = async (List) => {
  debugger
    try {
      let Image = $(List.newRow).find("td").eq(0).text();
      let oldSortId = $(List.newRow).find("td").eq(1).text();
      let newSortId = $(List.oldRow).find("td").eq(1).text();
      await corefetch(
        `Facility/SortFacilities?ImageId=${Image}&newSortId=${newSortId}&oldSortId=${oldSortId}`
      );
      setrefreshflag(refreshflag + 1);
    } catch (error) {
      console.error("Error during row reorder:", error);
    }
  };

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };
  useEffect(() => {}, [facilityDetails]);
  const clearForm = () => {
    toggleModal(false);
    setFacilityDetails({
      FacilityForm: {
        FacilityID: 0,
        FacilityName: "",
        Height: 0,
        FloorArea: "",
        StandardRate: 0,
        MinimumRate: 0,
        BaseCapacity: 0,
        MaxCapacity: 0,
        SimpleView: "",
        DetailedView: "",
        Latitude: "",
        Longitude: "",
        Image: "",
        OldImagePath: "",
      },
      SeatingDetails: [],
      Features: [],
      VirtualMapping: [],
      Layout: [],
    });
    setEditVisible(false);
  };
  const handleEditClick = async (e) => {
    setTitle(e.facilityName);

    toggleModal(true);
    setCurrentStep(0);
    try {
      const response = await corefetch(
        `Facility/GetFacilityDetails?facilityID=${e.facilityID}`
      );

      if (response) {
        const fetchedData =
          response != null && response.length > 0 ? response[0] : [];

        setFacilityDetails({
          FacilityForm: {
            FacilityID: fetchedData?.facilityID || 0,
            FacilityName: fetchedData?.facilityName || "",
            Height: fetchedData?.height || 0,
            FloorArea: fetchedData?.floorArea || "",
            StandardRate: fetchedData?.standardRate || 0,
            MinimumRate: fetchedData?.minimumRate || 0,
            BaseCapacity: fetchedData?.baseCapacity || 0,
            MaxCapacity: fetchedData?.maxCapacity || 0,
            SimpleView: fetchedData?.simpleView || "",
            DetailedView: fetchedData?.detailedView || "",
            Latitude: fetchedData?.latitude || "",
            Longitude: fetchedData?.longitude || "",
            Image: fetchedData?.oldImagePath || "",
            OldImagePath: fetchedData?.oldImagePath || "",
            Description: fetchedData?.description || "",
          },
          SeatingDetails: fetchedData?.seatingDetails || [],
          Features: fetchedData?.features || [],
          VirtualMapping: fetchedData?.virtualMapping || [],
          Layout: fetchedData?.layout || [],
        });
        setEditVisible(true);

        // toggleModal((isEdit = false));
      } else {
        console.error("Failed to fetch data from server.");
      }
    } catch (error) {
      console.error("Error in API call:", error);
    }
  };
  const handleDeleteClick = async (e) => {
    const onDelete = async () => {
      let SavedBy = sessionUser();
      await corefetch(
        `Facility/DeleteFacility?id=${e.facilityID}`,
        true,
        false,
        true
      );
      setrefreshflag(refreshflag + 1);
    };
    confirmDelete(onDelete);
  };
  return (
    <>
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <h3 className="page-title">Venues</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Configuration</a>
              </li>
              <li className="breadcrumb-item active">Venues</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="card bg-white">
        <div className="card-body">
          <div className="col-auto ms-auto">
            <div className="row">
              <div className="col-sm-6"></div>
              <div className="col-auto float-end ms-auto">
                <div className="d-flex justify-content-end mb-2">
                  <Button name="Add" onClick={() => toggleModal(false)} />
                </div>
                {/* <div className="d-flex justify-content-end mb-2">
                  <Button name="Add" onClick={toggleModal} />
                </div> */}
              </div>
            </div>

            <div>
            <i>
                <span style={{ backgroundColor: "yellow", fontWeight: "bold" }}>
                  Note:
                </span>{" "}
                This module supports drag-and-drop functionality. You can easily
                rearrange or move data as needed.
              </i>
              <KendoGrid
                name="welcomeTo-config"
                url={CorebaseURL + "Facility/GetFacilityDetails"}
                // data={facilityData}
                schema={{}}
                columns={[
                  {
                    field: "facilityID",
                    filterable: false,
                    hidden: true,
                  },
                  { field: "orderBy", hidden: true },
                  {
                    field: "facilityName",
                    title: "Venue Name",
                  },
                  {
                    field: "oldImagePath",
                    title: "Images",

                    template: (dataItem) =>
                      dataItem.oldImagePath
                        ? `<img src="${ImageURL}${dataItem.oldImagePath}" width="40px" height="40px" />`
                        : `<div>No Image</div>`,
                  },
                ]}
                showOptions={true}
                showEdit={true}
                onEditClick={handleEditClick}
                onDeleteClick={handleDeleteClick}
                showDelete={true}
                enableRowReorderable={true}
                onRowReorder={onRowReorderChange}
                disableExportExcel={true}
                refreshWhen={refreshflag}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Modal Component */}
      {isModalOpen && (
        <div className="modal show d-block wizard-modal">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editVisible ? `${title} - Edit` : "Add"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={toggleModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="progress-container">
                  <div
                    className="progress-bar"
                    style={{
                      width: `${((currentStep + 1) / steps.length) * 100}%`,
                    }}
                  ></div>
                </div>

                <div className="step-indicator-container">
                  {steps.map((step, index) => (
                    <div
                      key={index}
                      className={`step-indicator ${
                        currentStep === index ? "active" : ""
                      } ${
                        currentStep > index
                          ? "can-go-back"
                          : "cannot-go-forward"
                      }`}
                      onClick={() => {
                        // Allow navigation to previous steps
                        if (index <= currentStep) {
                          setCurrentStep(index);
                        }
                      }}
                    >
                      {step.label}
                    </div>
                  ))}
                </div>

                <div className="step-content">{steps[currentStep].content}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
